import md5 from 'js-md5';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
dayjs.extend(dayjsPluginUTC);

const generateAuthToken = (authKey, nowDate, pParam) => {
  const s =
    window.atob(authKey) +
    dayjs(nowDate)
      .utc()
      .utcOffset(8)
      .format('YYYYMMDDHHmmssSSS') +
    window.atob(pParam);
  const md5_s = md5.hex(s);
  const v_Key = md5_s.substring(5, 10);
  return window.atob(authKey) + '_' + v_Key;
};

const isString = (obj) => {
  return Object.prototype.toString.call(obj) == '[object String]';
};

const isStringNull = (str) => {
  if (!str) {
    return true;
  }

  try {
    if (!isString(str)) {
      return false;
    }
  } catch (err) {
    console.error(err);
  }

  if (str.length == 0) {
    return true;
  }

  try {
    if (str.toLowerCase() == 'null') {
      return true;
    }
    if (str.toLowerCase() == 'undefine') {
      return true;
    }
    if (str.toLowerCase() == 'undefined') {
      return true;
    }
  } catch (err) {
    console.log(err);
  }
  return false;
};

const isStringNotNull = (str) => {
  return !isStringNull(str);
};

/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = (name) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

const removeStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

const myTrim = (x) => {
  return x.replace(/^\s+|\s+$/gm, '');
};

const GgpsToBgps = (gg_lng, gg_lat) => {
  var X_PI = (Math.PI * 3000.0) / 180.0;
  var x = gg_lng;
  var y = gg_lat;
  var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
  var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
  var bd_lng = z * Math.cos(theta) + 0.0065;
  var bd_lat = z * Math.sin(theta) + 0.006;
  return { bd_lat: bd_lat, bd_lng: bd_lng };
};

const BgpsToGgps = (bd_lng, bd_lat) => {
  var X_PI = (Math.PI * 3000.0) / 180.0;
  var x = bd_lng - 0.0065;
  var y = bd_lat - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
  var gg_lng = z * Math.cos(theta);
  var gg_lat = z * Math.sin(theta);
  return { lng: gg_lng, lat: gg_lat };
};

export {
  generateAuthToken,
  isStringNull,
  isStringNotNull,
  setStore,
  getStore,
  removeStore,
  myTrim,
  GgpsToBgps,
  BgpsToGgps
};
